import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70f68ecb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "p-4 max-w-md w-full" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3xl font-bold my-8" }, "Авторизация", -1))
const _hoisted_4 = { class: "" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Войти ")

import { reactive, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

import { useAsync } from "@/use/useAsync";
import { useAuth } from "@/use/useAuth";
import { useMessage } from "@/plugins/message";

import UiCard from "@/plugins/ui/components/card/UiCard.vue";

import UiTextField from "@/components/ui/UiTextField.vue";
import UiCheckbox from "@/components/ui/UiCheckbox.vue";
import UiBtn from "@/components/ui/UiBtn.vue";

import AppLogo from "@/components/AppLogo.vue";
import axios from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const router = useRouter();
const message = useMessage();
const { login, logout } = useAuth();

const credential = reactive({
  isEntrant: false,
  login: "",
  pwd: "",
  user_agent: navigator.userAgent,
});

const route = useRoute();

const onSubmit = useAsync(async () => {
  try {
    await login(credential);
    router.push("/");
  } catch (e) {
    if (axios.isAxiosError(e)) {
      message({ text: e.response?.data.errors.message, type: "danger" });
    }
  }
});

onMounted(async () => {
  await logout();

  if (route.query && route.query.credential) {
    const [login, pwd, isEntrant] = JSON.parse(
      window.atob(String(route.query.credential))
    );

    credential.login = String(login);
    credential.pwd = String(pwd);
    credential.isEntrant = isEntrant;

    onSubmit.execute();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppLogo),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(UiCard, null, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(onSubmit).execute()), ["prevent"]))
            }, [
              _createVNode(UiTextField, {
                modelValue: credential.login,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((credential.login) = $event)),
                modelModifiers: { trim: true },
                label: "Логин (лицевой счет)"
              }, null, 8, ["modelValue"]),
              _createVNode(UiTextField, {
                modelValue: credential.pwd,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((credential.pwd) = $event)),
                modelModifiers: { trim: true },
                type: "password",
                label: "Пароль"
              }, null, 8, ["modelValue"]),
              _createVNode(UiBtn, {
                type: "submit",
                loading: _unref(onSubmit).isPending.value,
                disabled: _unref(onSubmit).isPending.value,
                class: "mt-4",
                stretched: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["loading", "disabled"])
            ], 32)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})